package com.macrofocus.eflux.ui.morphing

import org.locationtech.jts.geom.*

fun combinedMorphing(
    line1: LineString,
    line2: LineString,
    step: Double,
    steps: Int,
    tolerance: Double? = null // Optional tolerance for simplifying the output
): LineString {
    val geometryFactory = GeometryFactory()

    val interpolationFactor = step / steps
    val intermediateCoords = mutableListOf<Coordinate>()

    for (t in 0..line1.numPoints - 1) {
        val parameterT = t.toDouble() / 100
        val coord1 = line1.getCoordinateN(t)
        val coord2 = line2.getCoordinateN(t)

        // Morph between the two points
        val element = morphCoordinates(coord1, coord2, step, steps)
        intermediateCoords.add(element)
    }

    // Create a LineString for the current step
    val morphedLine = geometryFactory.createLineString(intermediateCoords.toTypedArray())

    // Simplify if tolerance is provided
    val simplifiedLine = if (tolerance != null) simplifyLine(morphedLine, tolerance) else morphedLine

    return simplifiedLine
}

fun combinedMorphing(
    line1: LinearRing,
    line2: LinearRing,
    step: Double,
    steps: Int,
    tolerance: Double? = null // Optional tolerance for simplifying the output
): LinearRing {
    val geometryFactory = GeometryFactory()

    val interpolationFactor = step / steps
    val intermediateCoords = mutableListOf<Coordinate>()

    if(line1.numPoints != line2.numPoints) {
        throw IllegalArgumentException("Not the same number of points ${line1.numPoints}, ${line2.numPoints}")
    }

    for (t in 0 until line1.numPoints) {
        val parameterT = t.toDouble() / 100
        val coord1 = line1.getCoordinateN(t)
        val coord2 = line2.getCoordinateN(t)

        // Morph between the two points
        val element = morphCoordinates(coord1, coord2, step, steps)
        intermediateCoords.add(element)
    }

    // Create a LineString for the current step
    val morphedLine = geometryFactory.createLinearRing(intermediateCoords.toTypedArray())

    // Simplify if tolerance is provided
    val simplifiedLine = if (tolerance != null) simplifyLine(morphedLine, tolerance) else morphedLine

    return simplifiedLine
}

fun combinedMorphing(
    line1: Polygon,
    line2: Polygon,
    step: Double,
    steps: Int,
    tolerance: Double? = null // Optional tolerance for simplifying the output
): Polygon {
   return line1.factory.createPolygon(combinedMorphing(line1.exteriorRing!!, line2.exteriorRing!!, step, steps, tolerance))
}
